import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-modal-decision",
    templateUrl: "./modal-decision.component.html",
    styleUrls: ["./modal-decision.component.scss"]
})
export class ModalDecisionComponent {
    public mensaje: string;

    constructor(private activeModal: NgbActiveModal) { }

    public cerrar(mensaje: string): void {
        this.activeModal.close(mensaje);
    }
}
